/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ marketplaces: NonNullable<unknown> }} Pricing_Hero_SubtitleInputs */

const tr_pricing_hero_subtitle = /** @type {(inputs: Pricing_Hero_SubtitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Tüm pazaryerleri (${i?.marketplaces}), e-Fatura, kargo ve AI otomasyonları tek panelde. Önce ücretsiz dene, sonra firmanıza uygun planı seçin.`)
};

const en_pricing_hero_subtitle = /** @type {(inputs: Pricing_Hero_SubtitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`All marketplaces (${i?.marketplaces}), e-invoicing, shipping, and AI automations in one panel. Try for free first, then choose the plan that fits your company.`)
};

const de_pricing_hero_subtitle = /** @type {(inputs: Pricing_Hero_SubtitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Alle Marktplätze (${i?.marketplaces}), E-Rechnung, Versand und AI-Automatisierungen in einem Panel. Erst kostenlos testen, dann den passenden Plan für Ihr Unternehmen wählen.`)
};

const ru_pricing_hero_subtitle = /** @type {(inputs: Pricing_Hero_SubtitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Все маркетплейсы (${i?.marketplaces}), электронные счета, доставка и ИИ-автоматизация в одной панели. Сначала попробуйте бесплатно, затем выберите подходящий тариф для вашей компании.`)
};

/**
* | output |
* | --- |
* | "All marketplaces ({marketplaces}), e-invoicing, shipping, and AI automations in one panel. Try for free first, then choose the plan that fits your company." |
*
* @param {Pricing_Hero_SubtitleInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const pricing_hero_subtitle = /** @type {((inputs: Pricing_Hero_SubtitleInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pricing_Hero_SubtitleInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pricing_hero_subtitle(inputs)
	if (locale === "de") return de_pricing_hero_subtitle(inputs)
	if (locale === "ru") return ru_pricing_hero_subtitle(inputs)
	return tr_pricing_hero_subtitle(inputs)
});